import React from 'react';
import { AppBar, Box, Button, Container, styled, Toolbar, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { APP_HEADER_HEIGHT_SM, APP_HEADER_HEIGHT_XS, SITE_TITLE } from '../../utils';

const AppContent = styled(Container)(({ theme }) => ({
  marginTop: APP_HEADER_HEIGHT_XS,
  paddingTop: theme.spacing(1),
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    marginTop: APP_HEADER_HEIGHT_SM,
  },
}));

export default function PublicRulesLayout({
  children,
  bgcolor = '#fff',
}: {
  children: React.ReactNode;
  bgcolor?: string;
}) {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor }}>
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="h5" sx={{ flexGrow: 1 }}>
            {SITE_TITLE}
          </Typography>
          <Button color="inherit" component={RouterLink} to="/">
            Log In
          </Button>
        </Toolbar>
      </AppBar>
      <AppContent maxWidth={false}>{children}</AppContent>
    </Box>
  );
}
